
    import './styles.scoped.css';
    export default {
  "universal-toolbar": "awsui_universal-toolbar_1kzri_3aah1_13",
  "with-ai-drawer": "awsui_with-ai-drawer_1kzri_3aah1_32",
  "universal-toolbar-ai-custom": "awsui_universal-toolbar-ai-custom_1kzri_3aah1_32",
  "disable-body-scroll": "awsui_disable-body-scroll_1kzri_3aah1_71",
  "toolbar-container": "awsui_toolbar-container_1kzri_3aah1_124",
  "universal-toolbar-nav": "awsui_universal-toolbar-nav_1kzri_3aah1_144",
  "universal-toolbar-breadcrumbs": "awsui_universal-toolbar-breadcrumbs_1kzri_3aah1_149",
  "universal-toolbar-drawers": "awsui_universal-toolbar-drawers_1kzri_3aah1_158",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_1kzri_3aah1_166",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_1kzri_3aah1_167",
  "drawers-trigger-content": "awsui_drawers-trigger-content_1kzri_3aah1_209",
  "group-divider": "awsui_group-divider_1kzri_3aah1_219",
  "drawers-trigger": "awsui_drawers-trigger_1kzri_3aah1_209",
  "block-body-scroll": "awsui_block-body-scroll_1kzri_3aah1_232",
  "external-breadcrumbs": "awsui_external-breadcrumbs_1kzri_3aah1_236"
};
  